<div
    class="bg-primary-50 rounded-3xl p-2 flex justify-between px-3 items-center"
>
    <h2 class="text-tertiary-900 !mb-0 !ml-2">{{ title }}</h2>
    <div class="flex space-x-2">
        @if (navItems.quaternaries) {
            @for (quaternary of navItems.quaternaries; track quaternary.title) {
                <ng-container
                    *ngTemplateOutlet="
                        navButton;
                        context: {
                            item: quaternary,
                            buttonType: 'stroked',
                        }
                    "
                ></ng-container>
            }
        }

        @if (navItems.secondaries) {
            @for (secondary of navItems.secondaries; track secondary.title) {
                <ng-container
                    *ngTemplateOutlet="
                        navButton;
                        context: {
                            item: secondary,
                            buttonType: 'raised',
                        }
                    "
                ></ng-container>
            }
        }

        @if (navItems.tertiaries) {
            @for (tertiary of navItems.tertiaries; track tertiary.title) {
                <ng-container
                    *ngTemplateOutlet="
                        navButton;
                        context: {
                            item: tertiary,
                            buttonType: 'raised',
                        }
                    "
                ></ng-container>
            }
        }

        @if (navItems.primaries) {
            @for (primary of navItems.primaries; track primary.title) {
                <ng-container
                    *ngTemplateOutlet="
                        navButton;
                        context: {
                            item: primary,
                            buttonType: 'raised',
                            color: 'primary',
                        }
                    "
                ></ng-container>
            }
        }
    </div>
</div>

<ng-template
    #navButton
    let-item="item"
    let-buttonType="buttonType"
    let-color="color"
>
    @if (item.buttonMenuOptions) {
        <app-button-menu
            [title]="item.title"
            [classList]="item.classList"
            [options]="item.buttonMenuOptions"
        ></app-button-menu>
    } @else {
        @if (buttonType === 'stroked') {
            <button
                [class]="item.classList"
                type="button"
                mat-stroked-button
                [color]="color"
                [routerLink]="item.routerLink"
                (click)="item.action && item.action()"
                [title]="item.title"
                class="flex items-center"
                [disabled]="item.disabled"
            >
                @if (item.imageUrl) {
                    <span class="flex items-center space-x-2">
                        <img
                            [src]="item.imageUrl"
                            [alt]="item.title"
                            class="w-5 h-5"
                        />
                        <span>{{ item.title }}</span>
                    </span>
                } @else {
                    <span>{{ item.title }}</span>
                }
            </button>
        } @else {
            <button
                [class]="item.classList"
                type="button"
                mat-raised-button
                [color]="color"
                [routerLink]="item.routerLink"
                (click)="item.action && item.action()"
                [title]="item.title"
                class="flex items-center"
                [disabled]="item.disabled"
            >
                @if (item.imageUrl) {
                    <span class="flex items-center space-x-2">
                        <img
                            [src]="item.imageUrl"
                            [alt]="item.title"
                            class="w-5 h-5"
                        />
                        <span>{{ item.title }}</span>
                    </span>
                } @else {
                    <span>{{ item.title }}</span>
                }
            </button>
        }
    }
</ng-template>
